<template>
  <TheSidebar>
    <template v-slot:header-nav>
      <div class="sidebar__event-header">
        <router-link :to="{name: 'eventList'}" class="back">
          <CIcon name="cipChevronLeft" size="custom-size" style="margin-left: -5px"
                 :height="22"/>
          <span v-translate>Change event</span>
        </router-link>
        <h4 class="mb-1">
          {{ currentEventName }}
          <CIcon name="cipGlobe" class="text-primary mb-1" style="" width="20" v-if="thirdLevelDomain"/>
        </h4>
        <div class="ml-0 d-flex align-items-center" v-if="currentEventStartDate">
          <CIcon name="cipCalendar" size="custom-size" :height="18" class="mr-2"/>
          <span class="font-weight-normal">{{ currentEventStartDate|formatDate }}</span>
        </div>


        <UploadStats v-if="hasPerm('photo_search.stats')"/>
        <ProcessStats v-if="hasPerm('photo_search.stats')"/>
      </div>
    </template>

    <CSidebarNav>
      <OverviewNav/>
      <SetupNav/>
      <GalleryNav @createGallery="$emit('createGallery')"/>
      <InvitationsNav/>
      <MediaNav/>
      <InsightNav/>
    </CSidebarNav>
    <CSidebarFooter v-if="hasPerm('event_wizard.publish')">
      <template v-if="isDraft">
        <div class="draft">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <CIcon name="cipSignal" :width="24" class="mr-2 text-primary"/>
            <CBadge color="light" class="badge-outline px-2">
              <CIcon name="cipDot" :width="8" class="mr-2 text-warning"/>
              <translate>Draft</translate>
            </CBadge>
          </div>
          <div class="mb-3">
              <h5 class="m-0 font-weight-semi-bold" v-translate>Activate event</h5>
              <span v-translate>Go live and start selling</span>
          </div>
          <CButton block color="primary" size="sm" @click="onPublish" v-translate>
            Activate
          </CButton>
        </div>
      </template>
      <template v-else>
        <div class="published">
          <div class="d-flex justify-content-between mb-2">
            <div>
              <h6 class="mb-0 font-weight-semi-bold" v-translate>Event active</h6>
              <span v-translate>From</span> {{ currentEventStartDate|formatDate('L') }}
            </div>
            <div>
            <CBadge color="light" class="badge-outline px-2">
              <CIcon name="cipDot" :width="8" class="mr-2 text-success"/>
              <translate>Active</translate>
            </CBadge>
              </div>
          </div>
        </div>
      </template>
    </CSidebarFooter>
    <PublishEventModal ref="publishEventModal" @published="onPublished" />
    <PublishedEventModal ref="publishedEventModal"/>
  </TheSidebar>
</template>
<script>


import {mapGetters} from "vuex";
import TheSidebar from "@/containers/TheSidebar.vue";
import SetupNav from "@/domain/eventManage/nav/SetupNav.vue";
import OverviewNav from "@/domain/eventManage/nav/OverviewNav.vue";
import InsightNav from "@/domain/eventManage/nav/InsightNav.vue";
import MediaNav from "@/domain/eventManage/nav/MediaNav.vue";
import InvitationsNav from "@/domain/eventManage/nav/InvitationsNav.vue";
import GalleryNav from "@/domain/eventManage/nav/GalleryNav.vue";
import PublishEventModal from "@/domain/events/components/PublishEventModal.vue";
import UploadStats from "@/domain/events/components/UploadStats.vue";
import ProcessStats from "@/domain/events/components/ProcessStats.vue";
import PublishedEventModal from "@/domain/events/components/PublishedEventModal.vue";

export default {
  name: 'EventManagerSidebar',
  emits: ['createGallery'],
  components: {
    PublishedEventModal,
    ProcessStats,
    UploadStats,
    PublishEventModal, GalleryNav, InvitationsNav, MediaNav, InsightNav, OverviewNav, SetupNav, TheSidebar
  },
  computed: {
    ...mapGetters('event', [
      'picaServiceId',
      'currentEventStartDate',
      'currentEventName',
      'thirdLevelDomain',
      'isDraft',
    ]),
  },
  methods: {
    onPublish() {
      this.$refs.publishEventModal.open()
    },
    onPublished() {
      this.$refs.publishedEventModal.open()
    },
  }
}
</script>
